export const locale = {
    lang: 'es',
    multiselect_pools: {
        POOLS_TITLE: 'ASIGNAR A POOLS DE COLLECCIONES',
    }
};
